import { render, staticRenderFns } from "./CompetitionTable.vue?vue&type=template&id=0c8a434e&scoped=true"
import script from "./CompetitionTable.vue?vue&type=script&lang=js"
export * from "./CompetitionTable.vue?vue&type=script&lang=js"
import style0 from "./CompetitionTable.vue?vue&type=style&index=0&id=0c8a434e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8a434e",
  null
  
)

export default component.exports